<template>
  <div class="questions">
    <div class="question" v-for="(question, index) in questions" :key="index">
      <div class="title-container" @click="toggle(index)">
        <h5 class="title">{{ question.title }}</h5>
        <button :class="['toggle', activeIndex === index && 'active']">
          <Plus />
        </button>
      </div>

      <transition @enter="enter" @leave="leave">
        <div
          v-show="activeIndex === index"
          class="answer-wrapper"
          ref="answers"
        >
          <div class="answer-inner">
            <p class="answer">{{ question.answer }}</p>
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import Plus from "@/assets/icons/plus.svg";

export default {
  name: "Questions",
  components: { Plus },
  props: { questions: { type: Array, default: () => [] } },
  data() {
    return {
      activeIndex: null,
    };
  },
  methods: {
    toggle(index) {
      this.activeIndex = this.activeIndex === index ? null : index;
    },
    enter(el) {
      const inner = el.querySelector(".answer-inner");
      const height = inner.scrollHeight;

      el.style.height = "0px";
      el.style.overflow = "hidden";

      requestAnimationFrame(() => {
        el.style.transition = "height 0.3s ease";
        el.style.height = height + "px";
      });
    },
    leave(el) {
      const inner = el.querySelector(".answer-inner");
      const height = inner.scrollHeight;

      el.style.height = height + "px";
      el.style.overflow = "hidden";

      requestAnimationFrame(() => {
        el.style.transition = "height 0.3s ease";
        el.style.height = "0px";
      });
    },
  },
};
</script>

<style scoped lang="less">
.questions {
  width: 100%;

  .question {
    background-color: #fff;
    display: flex;
    flex-direction: column;
    padding: 24px 0;
    &:first-of-type {
      border-top: 3px solid #a5d8ff;
    }
    &:not(first-of-type) {
      border-bottom: 3px solid #a5d8ff;
    }

    .title-container {
      display: flex;
      justify-content: space-between;
      align-items: center;
      cursor: pointer;

      .title {
        font-family: Montserrat;
        font-weight: 600;
        font-size: 28px;
        line-height: 1;
        margin: 0;
        @media (max-width: 767px) {
          font-size: 20px;
        }
      }

      .toggle {
        background-color: #fff;
        display: flex;
        align-items: center;
        justify-content: center;
        height: 34px;
        width: 34px;
        svg {
          transition: transform 0.3s ease;
        }
      }

      .active svg {
        transform: rotate(45deg);
      }
    }

    .answer-wrapper {
      overflow: hidden;

      .answer-inner {
        padding-top: 16px;
      }

      .answer {
        white-space: pre-line;
        font-family: Montserrat;
        font-weight: 500;
        font-size: 20px;
        line-height: 1;
        color: #484e55;
        margin: 0;
        padding: 0;
        @media (max-width: 767px) {
          font-size: 14px;
        }
      }
    }
  }
}
</style>
